import { kebabCase, replace, split } from 'lodash';
import { searchTypes } from '../../helpers/ui/searchTypes';
import logger from './../logger/logger';

export function searchPageUrlGenerator(content: {
  type: string;
  propertyType?: string;
  title?: string;
  id?: string | number;
  slug?: string;
  projectNetPropertyId?: number;
}) {
  if (!content) {
    return `/list/`;
  }
  const type = searchTypes[content.type];
  if (content.type == 'project' && content?.projectNetPropertyId) {
    return getProjectNetProjectHref(
      content.propertyType,
      content.projectNetPropertyId,
    );
  } else if (content.type === 'project') {
    const propertyType = split(content.propertyType, ',');
    let formatPartUrl =
      '/' +
      formatMultiplePropertyType(propertyType) +
      '/project/' +
      formatUrlWithName(replace(content.title, '-', ' '));
    if (content.id) {
      formatPartUrl = `${formatPartUrl}-${content.id}`;
    }

    return `${formatPartUrl}/`;
  }

  return `/list/${type}${content.slug}/`;
}

/**
 * @deprecated
 * @See ./landingPageUrlGenerator.ts
 */
export function landingPageUrlGenerator(content: { title: string }) {
  if (!content?.title) {
    return `/`;
  }

  return `/${kebabCase(content.title)}/`;
}

/**
 *
 * @param {Partial<{propertyType: string|string[], title: string, id: number, postCategory:string, link:string}>} content
 * @return {string}
 */
export function getContentPagePath(content: {
  propertyType?: string[];
  title?: string;
  id?: number | string;
  postCategory?: string;
  link?: string;
}) {
  const { propertyType, title, id, postCategory, link } = content;
  if (link) {
    try {
      const url = decodeURI(new URL(link).pathname);
      return url.endsWith('/') ? url : `${url}/`;
    } catch {
      logger.logError(
        'getContentPagePath',
        `something wrong when decodeURI, post id: ${id}, link: ${link}`,
      );
      return undefined;
    }
  } else {
    logger.logError(
      'getContentPagePath',
      'Link params should not be empty when calling the function. ' +
        'Legacy fallback will be removed in the near future.',
    );
    return generateLegacyContentPageUrl({
      propertyType,
      title,
      id,
      postCategory,
    });
  }
}

function generateLegacyContentPageUrl({
  propertyType,
  title,
  id,
  postCategory,
}: {
  propertyType: string[];
  title: string;
  id: number | string;
  postCategory: string;
}) {
  let formatPartUrl = '/' + formatMultiplePropertyType(propertyType);
  if (id) {
    formatPartUrl = `${formatPartUrl}/${formatTitle(title)}-${id}`;
  }
  return `${formatPartUrl}${
    postCategory !== undefined ? '-' + formatUrlWithName(postCategory) : ''
  }/`;
}

function formatTitle(title: string) {
  return `${formatUrlWithName(replace(title, '-', ' '))}`;
}

export function getProjectPagePath(link: string) {
  if (link) {
    try {
      const url = decodeURI(new URL(link).pathname);
      return url.endsWith('/') ? url : `${url}/`;
    } catch {
      logger.logError(
        'getProjectPagePath',
        `something wrong when decodeURI,link: ${link}`,
      );
      return undefined;
    }
  }
}

export const getProjectNetProjectHref = (
  propertyType: string,
  projectNetPropertyId: number | string,
) =>
  projectNetPropertyId
    ? `/project/${propertyType}/${projectNetPropertyId}`
    : null;

function formatUrlWithName(name: string) {
  return kebabCase(name);
}

function formatMultiplePropertyType(propertyType: string[]) {
  return Array.isArray(propertyType) && propertyType.length > 0
    ? kebabCase(propertyType.join(' '))
    : 'article';
}
